import { useEffect, type ReactNode } from "react";

import { PRODUCT_NAME } from "../brand.js";
import { KeyMark } from "./KeyMark.js";

export interface AuthShellProps {
	title: string;
	description?: ReactNode;
	children: ReactNode;
	footer?: ReactNode;
	productName?: string;
	/** When set, used for `document.title` instead of the default product · title pattern. */
	documentTitle?: string;
}

export function AuthShell({
	title,
	description,
	children,
	footer,
	productName = PRODUCT_NAME,
	documentTitle,
}: AuthShellProps) {
	useEffect(() => {
		if (documentTitle !== undefined) {
			document.title = documentTitle;
			return;
		}
		document.title = title.includes(productName) ? title : `${productName} · ${title}`;
	}, [documentTitle, productName, title]);

	return (
		<div className="auth">
			<main id="main">
				<div className="auth-brand">
					<KeyMark title={productName} />
					<span>{productName}</span>
				</div>
				<div className="auth-card">
					<h1>{title}</h1>
					{description && <p className="auth-lead">{description}</p>}
					{children}
				</div>
				{footer && <div className="auth-foot">{footer}</div>}
			</main>
		</div>
	);
}
